"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMSX Rest API
 * EMSX Rest API for Vet lookups
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APILocationPageDistanceToJSON = exports.APILocationPageDistanceFromJSONTyped = exports.APILocationPageDistanceFromJSON = exports.instanceOfAPILocationPageDistance = void 0;
const runtime_1 = require("../runtime");
const APIDistance_1 = require("./APIDistance");
const City_1 = require("./City");
/**
 * Check if a given object implements the APILocationPageDistance interface.
 */
function instanceOfAPILocationPageDistance(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "rcvs_accredited" in value;
    return isInstance;
}
exports.instanceOfAPILocationPageDistance = instanceOfAPILocationPageDistance;
function APILocationPageDistanceFromJSON(json) {
    return APILocationPageDistanceFromJSONTyped(json, false);
}
exports.APILocationPageDistanceFromJSON = APILocationPageDistanceFromJSON;
function APILocationPageDistanceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'placement_provider_name': !runtime_1.exists(json, 'placement_provider_name') ? undefined : json['placement_provider_name'],
        'address1': !runtime_1.exists(json, 'address1') ? undefined : json['address1'],
        'city': !runtime_1.exists(json, 'city') ? undefined : City_1.CityFromJSON(json['city']),
        'post_code': !runtime_1.exists(json, 'post_code') ? undefined : json['post_code'],
        'longitude': !runtime_1.exists(json, 'longitude') ? undefined : json['longitude'],
        'latitude': !runtime_1.exists(json, 'latitude') ? undefined : json['latitude'],
        'website': !runtime_1.exists(json, 'website') ? undefined : json['website'],
        'species_ids': !runtime_1.exists(json, 'species_ids') ? undefined : json['species_ids'],
        'placement_types_ids': !runtime_1.exists(json, 'placement_types_ids') ? undefined : json['placement_types_ids'],
        'practice_interests_ids': !runtime_1.exists(json, 'practice_interests_ids') ? undefined : json['practice_interests_ids'],
        'url': !runtime_1.exists(json, 'url') ? undefined : json['url'],
        'distance': !runtime_1.exists(json, 'distance') ? undefined : APIDistance_1.APIDistanceFromJSON(json['distance']),
        'rcvs_accredited': json['rcvs_accredited'],
    };
}
exports.APILocationPageDistanceFromJSONTyped = APILocationPageDistanceFromJSONTyped;
function APILocationPageDistanceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'placement_provider_name': value.placement_provider_name,
        'address1': value.address1,
        'city': City_1.CityToJSON(value.city),
        'post_code': value.post_code,
        'longitude': value.longitude,
        'latitude': value.latitude,
        'website': value.website,
        'species_ids': value.species_ids,
        'placement_types_ids': value.placement_types_ids,
        'practice_interests_ids': value.practice_interests_ids,
        'url': value.url,
        'distance': APIDistance_1.APIDistanceToJSON(value.distance),
        'rcvs_accredited': value.rcvs_accredited,
    };
}
exports.APILocationPageDistanceToJSON = APILocationPageDistanceToJSON;
